// extracted by mini-css-extract-plugin
module.exports = {"firstLine":"SidebarTeamContainer_firstLine__ZnhsT","secondLine":"SidebarTeamContainer_secondLine___wzqs","logo":"SidebarTeamContainer_logo__w8uG8"};